<template>
    <transition name="fade">
        <div class="ForceDisconnect" v-show="visible">
            <div class="fd-container">
                <ClockTimeFiveOutline/>
                <h1 class="fd-title"> {{ $t('Auf einen Moderator warten...') }}</h1>
            </div>         
        </div>  
    </transition>
</template>

<style scoped>
    .ForceDisconnect{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        background: #000000d0;
    }
    .fd-container{
        position: absolute;
        margin-top: 50px;
        background: white;
        border-radius: 10px;
        padding: 40px 100px;
        text-align: center;
    }
    .fd-title{
        margin-top: 20px;
        font-size: 18px;
        animation: pulse 2s infinite ease-in-out;
    }
    @keyframes pulse {
        0% {
            color: black;
        }
        50% {
            color: #afaeae;
        }
        100% {
            color: black;
        }
    }
    .material-design-icon{
        width: 70px;
        height: 70px;
    }
    .material-design-icon > .material-design-icon__svg {
        width: 70px;
        height: 70px;
        fill: rgb(255, 123, 0);
    }
</style>
    
<script>
import {mapState,mapGetters} from 'vuex';
import ClockTimeFiveOutline from 'vue-material-design-icons/ClockTimeFiveOutline.vue'

export default {
    components:{ClockTimeFiveOutline},
    computed: {
        ...mapState({
            isOnboardingComplete: (state) => state.session.isOnboardingComplete,
        }),
        ...mapGetters(['users']),
        visible(){
            let visible = true;
            if(this.isOnboardingComplete){
                this.users.forEach(u => {
                    if(u.getRole() === "moderator")
                        visible = false;
                    });
            }else{
                visible = false;
            }
            return visible;
        }
    },
}

</script>